import { NavigateFunction, NavigateOptions } from 'react-router-dom';
import { routes } from '../../../constants/strings/routes';
import { GridLevelName } from '../../grid-components/grid-types';
import {
  BillManagementGridFilterModelType,
  SubmissionManagementGridFilterModelType,
} from '../bill-grid-components/bill-management-types';

export const buildBillManagementUrl = (
  filters: Partial<
    BillManagementGridFilterModelType | SubmissionManagementGridFilterModelType
  >,
  level: GridLevelName = GridLevelName.BILL,
): string => {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value == null || value === '') {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach(val => params.append(key, val.toString()));
    } else {
      params.append(key, value.toString());
    }
  });

  const basePath =
    level === GridLevelName.BILL
      ? routes.billing.billManagement
      : routes.billing.submissionsManagement;

  return `${routes.billing.home}${basePath}?${params.toString()}`;
};

export const BillManagementNavigator = (
  filters: Partial<
    BillManagementGridFilterModelType | SubmissionManagementGridFilterModelType
  >,
  navigate: NavigateFunction,
  level: GridLevelName = GridLevelName.BILL,
  navigateOptions?: NavigateOptions,
): void => {
  const url = buildBillManagementUrl(filters, level);
  navigate(url, navigateOptions);
};
